"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MONTHS_EN = new Map([
    [1, 'Jan'],
    [2, 'Feb'],
    [3, 'Mar'],
    [4, 'Apr'],
    [5, 'May'],
    [6, 'Jun'],
    [7, 'Jul'],
    [8, 'Aug'],
    [9, 'Sep'],
    [10, 'Oct'],
    [11, 'Nov'],
    [12, 'Dec'],
]);
/** Translations of the GEDCOM date qualifiers. */
var QUALIFIERS_I18N = new Map([
    [
        'pl',
        new Map([
            ['cal', 'wyl.'],
            ['abt', 'ok.'],
            ['est', 'szac.'],
            ['before', 'przed'],
            ['after', 'po'],
        ]),
    ],
]);
var shortMonthCache = new Map();
function getShortMonth(month, locale) {
    if (!Intl || !Intl.DateTimeFormat) {
        return MONTHS_EN.get(month);
    }
    var cacheKey = month + "|" + (locale || '');
    if (shortMonthCache.has(cacheKey)) {
        return shortMonthCache.get(cacheKey);
    }
    var result = new Intl.DateTimeFormat(locale, { month: 'short' }).format(new Date(2000, month - 1));
    shortMonthCache.set(cacheKey, result);
    return result;
}
function getQualifier(qualifier, locale) {
    var language = locale && locale.split(/[-_]/)[0];
    var languageMap = language && QUALIFIERS_I18N.get(language);
    return languageMap ? languageMap.get(qualifier) : qualifier;
}
/** Simple date formatter. */
function formatDate(date, locale) {
    return [
        date.qualifier && getQualifier(date.qualifier, locale),
        date.day,
        date.month && getShortMonth(date.month, locale),
        date.year,
        date.text,
    ].join(' ');
}
exports.formatDate = formatDate;
/** Formats a DateOrRange object. */
function formatDateOrRange(dateOrRange, locale) {
    if (dateOrRange.date) {
        return formatDate(dateOrRange.date, locale);
    }
    if (!dateOrRange.dateRange) {
        return '';
    }
    var from = dateOrRange.dateRange.from && formatDate(dateOrRange.dateRange.from);
    var to = dateOrRange.dateRange.to && formatDate(dateOrRange.dateRange.to);
    if (from && to) {
        return from + " .. " + to;
    }
    if (from) {
        return getQualifier('after', locale) + " " + from;
    }
    if (to) {
        return getQualifier('before', locale) + " " + to;
    }
    return '';
}
exports.formatDateOrRange = formatDateOrRange;
